const safeName = (title) => String(title || 'export').replace(/[^a-zA-Z0-9]+/g, '_').toLowerCase();

/**
 * Write an array of flat objects to an .xlsx file, one sheet.
 * `columns` ([{header, key}] or strings) picks and orders the columns; omitted = all keys of row 1.
 */
export async function exportToXlsx(data, { title = 'Export', columns } = {}) {
  if (!data || data.length === 0) return;
  const XLSX = await import('xlsx');
  const cols = columns
    ? columns.map((c) => (typeof c === 'string' ? { header: c, key: c } : c))
    : Object.keys(data[0]).map((k) => ({ header: k, key: k }));
  const body = data.map((row) => cols.map((c) => {
    const v = row[c.key];
    if (v === null || v === undefined) return '';
    if (typeof v === 'object') return JSON.stringify(v);
    return v;
  }));
  const ws = XLSX.utils.aoa_to_sheet([cols.map((c) => c.header), ...body]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, safeName(title).slice(0, 31) || 'export');
  XLSX.writeFile(wb, `${safeName(title)}.xlsx`);
}

// Flat CSV text for plain object rows (used when a page gives ExportMenu `data`/`columns`
// instead of an MRT instance).
export function rowsToCsv(data, columns) {
  const cols = columns.map((c) => (typeof c === 'string' ? { header: c, key: c } : c));
  const esc = (v) => {
    let s = v === null || v === undefined ? '' : (typeof v === 'object' ? JSON.stringify(v) : String(v));
    if (typeof v === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`; // spreadsheet formula injection
    return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return [cols.map((c) => esc(c.header)).join(','), ...data.map((r) => cols.map((c) => esc(r[c.key])).join(','))].join('\r\n');
}

export function downloadText(text, filename, type = 'text/csv;charset=utf-8') {
  const url = URL.createObjectURL(new Blob([text], { type }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export { safeName };
